module.exports = __webpack_public_path__ + "static/media/IMG_3927.01178995.JPG";